import React, { useContext } from 'react';
import { View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { BottomSheet, Image, Overlay } from '@rneui/themed';
import PropTypes from 'prop-types';
import Login from './Login';
import Registration from './Registration';
import LayoutContext from '../../../contexts/Layout';
import { RegistrationContextProvider } from '../../../contexts/Registration';

const logo = require('../../../../assets/images/splash.png');

const Authentication = ({ isLogin, isRegister, setVisible, visible = false }) => {
    const {
        layout: {
            device: { isMobile },
            dimensions: height,
            styleGuide
        }
    } = useContext(LayoutContext);

    if (isMobile) {
        return (
            <SafeAreaProvider>
                <View style={{ flex: 1, padding: 30 }}>
                    <BottomSheet
                        backdropStyle={{ backgroundColor: '#8897a2', opacity: 0.5 }}
                        containerStyle={{ backgroundColor: '#fff', height: height, justifyContent: 'center' }}
                        isVisible={visible}
                        onBackdropPress={() => setVisible(false)}
                        testID='Authentication.Overlay'
                    >
                        <View style={{ marginHorizontal: styleGuide.indent }}>
                            <Image
                                childrenContainerStyle={{ height: undefined, width: undefined }}
                                containerStyle={{
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}
                                source={logo}
                                style={{
                                    height: 85,
                                    position: undefined,
                                    resizeMode: 'contain',
                                    tintColor: '#153d6e',
                                    width: 125
                                }}
                            />
                            {isLogin && <Login setVisible={setVisible} />}
                            {isRegister && (
                                <RegistrationContextProvider>
                                    <Registration setIsVisible={setVisible} />
                                </RegistrationContextProvider>
                            )}
                        </View>
                    </BottomSheet>
                </View>
            </SafeAreaProvider>
        );
    } else {
        return (
            <View style={{ flex: 1, padding: 30, maxHeight: '50%' }}>
                <Overlay
                    backdropStyle={{ backgroundColor: '#8897a2', opacity: 0.75 }}
                    isVisible={visible}
                    onBackdropPress={() => setVisible(false)}
                    overlayStyle={{ minHeight: '30%', minWidth: '30%' }}
                    testID='Authentication.Overlay'
                >
                    <Image
                        childrenContainerStyle={{ height: undefined, width: undefined }}
                        containerStyle={{
                            alignItems: 'center',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}
                        source={logo}
                        style={{
                            height: 150,
                            position: undefined,
                            resizeMode: 'contain',
                            tintColor: '#153d6e',
                            width: 200
                        }}
                    />
                    {isLogin && <Login setVisible={setVisible} />}
                    {isRegister && (
                        <RegistrationContextProvider>
                            <Registration setVisible={setVisible} />
                        </RegistrationContextProvider>
                    )}
                </Overlay>
            </View>
        );
    }
};

Authentication.propTypes = {
    isRegister: PropTypes.bool,
    visible: PropTypes.bool
};

export default Authentication;
